import { render } from "./LoginTabs.vue?vue&type=template&id=27269744&scoped=true"
import script from "./LoginTabs.vue?vue&type=script&lang=js"
export * from "./LoginTabs.vue?vue&type=script&lang=js"

import "./LoginTabs.vue?vue&type=style&index=0&id=27269744&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27269744"

export default script